import { SET_TOAST } from "constants/actionTypes";

/***** Redux actions that end up in the store *****/
export const setToast = (open, title, body, status, icon) => async dispatch => {
    dispatch({ type: SET_TOAST, payload: { open, title, body, status, icon } });
};
